import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=054c34a6"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports